import { BackendMessagesDE } from './backendMessagesDE';
import buildingDE from './messages/building.json';
import dashboardCustomizeDE from './messages/dashboard/customize.json';
import dashboardCustomTabsDE from './messages/dashboard/customTabs.json';
import dashboardDE from './messages/dashboard/dashboard.json';
import dashboardWidgetLibraryDE from './messages/dashboard/widgetLibrary.json';
import dashboardWidgetsDE from './messages/dashboard/widgets.json';
import invoiceLifecycleDE from './messages/invoiceLifecycle.json';
import leaseInventoryDE from './messages/leaseInventory.json';
import propertySiteDE from './messages/propertySite.json';
import tagDE from './messages/tag.json';
import technicDE from './messages/technic.json';
import ticketsDE from './messages/tickets.json';

export const MessagesDE = {
  ...BackendMessagesDE,
  building: buildingDE,
  dashboard: {
    ...dashboardDE,
    widgets: dashboardWidgetsDE,
    widgetLibrary: dashboardWidgetLibraryDE,
    customize: dashboardCustomizeDE,
    customTabs: dashboardCustomTabsDE,
  },
  invoiceLifecycle: invoiceLifecycleDE,
  leaseInventory: leaseInventoryDE,
  propertySite: propertySiteDE,
  tag: tagDE,
  technic: technicDE,
  tickets: ticketsDE,
};
